import { createSlice } from "@reduxjs/toolkit"
import { revertAllHotel } from "../action/user"

const initialState = {
  hotelService: {
    value: "",
    name: ""
  },
  hotelList: [],
  hotelID: "",
  hotelCategoryList: [],
  hotelCategoryDetail: [],
  dynamicFieldsGroup: [],
  linkCategory: {},
  hotelSubCategoryList: [],
  hotelNestedCategoryList: [],
  hotelNestedSubCategoryList: [],
  hotelServiceItemList: [],
  linkNestedCategory: { list: "Summary View" },
  linkNestedSubCategory: {},
  nestedSubcategoryData: {},
  categoryItemDetails: {},
  imageIds: {},
  itemId: "",
  itemCategoryId: "",
  categoryImageId: "",
  signatureDishImages: {}
}

const hotel = createSlice({
  name: "hotel",
  initialState: initialState,
  extraReducers: (builder) => builder.addCase(revertAllHotel, () => initialState),
  reducers: {
    setHotelService: (state, action) => {
      state.hotelService = action.payload
    },
    setHotelList: (state, action) => {
      state.hotelList = action.payload
    },
    setHotelId: (state, action) => {
      state.hotelID = action.payload
    },
    setHotelCategoryList: (state, action) => {
      state.hotelCategoryList = action.payload
    },
    setHotelCategoryDetail: (state, action) => {
      state.hotelCategoryDetail = action.payload
    },
    setDynamicFieldsGroup: (state, action) => {
      state.dynamicFieldsGroup = action.payload
    },
    setHotelCategoryLink: (state, action) => {
      state.linkCategory = action.payload
    },
    setCategoryListValue: (state, action) => {
      state.linkNestedCategory.list = action.payload
    },
    setHotelSubCategoryList: (state, action) => {
      state.hotelSubCategoryList = action.payload
    },
    setHotelNestedCategoryList: (state, action) => {
      state.hotelNestedCategoryList = action.payload
    },
    setHotelNestedSubCategoryList: (state, action) => {
      state.hotelNestedSubCategoryList = action.payload
    },
    setHotelServiceItemList: (state, action) => {
      state.hotelServiceItemList = action.payload
    },
    setHotelNestedCategoryLink: (state, action) => {
      state.linkNestedCategory = action.payload
    },
    setHotelNestedSubCategoryLink: (state, action) => {
      state.linkNestedSubCategory = action.payload
    },
    setNestedSubcategoryData: (state, action) => {
      state.nestedSubcategoryData = action.payload
    },
    setCategoryItemDetails: (state, action) => {
      state.categoryItemDetails = action.payload
    },
    setImageId: (state, action) => {
      const { sectionKey, key, id } = action.payload

      if (!state.imageIds) {
        state.imageIds = {}
      }

      if (!state.imageIds[sectionKey]) {
        state.imageIds[sectionKey] = {}
      }

      if (!state.imageIds[sectionKey][key]) {
        state.imageIds[sectionKey][key] = []
      }

      if (!state.imageIds[sectionKey][key].includes(id)) {
        state.imageIds[sectionKey][key].push(id)
      }
    },
    removeImageId: (state, action) => {
      const { key, sectionKey } = action.payload

      if (state.imageIds?.[sectionKey]?.[key]) {
        delete state.imageIds[sectionKey][key]

        if (Object.keys(state.imageIds[sectionKey]).length === 0) {
          delete state.imageIds[sectionKey]
        }
      }
    },
    resetImageIds: (state) => {
      state.imageIds = {}
    },
    setItemId: (state, action) => {
      state.itemId = action.payload
    },
    setItemCategoryId: (state, action) => {
      state.itemCategoryId = action.payload
    },
    setCategoryImageId: (state, action) => {
      state.categoryImageId = action.payload
    },
    setSignatureDishImageId: (state, action) => {
      const { index, fieldKey, id } = action.payload

      if (!state.signatureDishImages[index]) {
        state.signatureDishImages[index] = {}
      }

      state.signatureDishImages[index][fieldKey] = [id]
    },

    resetSignatureDishImages: (state) => {
      state.signatureDishImages = {}
    }
  }
})

export default hotel
export const hotelAction = hotel.actions
